import gql from 'graphql-tag';

export const ListSneakerModelsQuery = gql`
  query($filter: JSON) {
    SneakerModels(sort: [["orderPriority", "desc"], ["date", "asc"]], filter: $filter) {
      _id
      name
      date
      orderPriority
      updatedAt
      createdAt
      isDeleted
      images
    }
  }
`;

export const SneakerModelDetailsQuery = gql`
  query($id: String!) {
    SneakerModel(filter:{_id: $id}) {
      _id
      name
      date
      orderPriority
      updatedAt
      createdAt
      images
    }
  }
`;

export const CreateSneakerModelMutation = gql`
  mutation($record: JSON) {
    createSneakerModel(record: $record) {
      _id
    }
  }
`;

export const UpdateSneakerModelMutation = gql`
  mutation($id: String!, $update: JSON) {
    updateSneakerModel(filter: {_id: $id}, update: $update) {
      _id
      name
      date
      orderPriority
      isDeleted
    }
  }
`;

export const DeleteSneakerModelMutation = gql`
  mutation($id: String!) {
    deleteSneakerModel(query: {_id: $id})
  }
`;
